import React from 'react';
import { Box, Typography } from '@mui/material';

const PanelFAQ = () => {

  return (
    <Box sx={{ backgroundColor: (theme) => theme.palette.secondary.main, color: (theme) => theme.palette.text.main, padding: 2 }}>
      <Typography variant="h4" sx={{ marginBottom: 3 }}>FAQ</Typography>
      
      <Box>
        <Typography variant="h6">For all the challenge details, including program rules, levels and recommended AI tools, check out the <a target="_blank" href="https://motsol.ink/AIGuruFAQ">FAQ</a>.</Typography>
      </Box>
    </Box>
  );
};

export default PanelFAQ;